import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from "@mui/material"
import React from "react"
import { TableEmptyState } from "../TableEmptyState"


interface Column {
  id: string
  label: string
  minWidth?: number
  align?: 'left'
}

export interface TableData {
  title: string
  columnHeaders: string[]
  rows: string[][]
}

interface Top20TableProps {
  data?: TableData
}

export default function Top20Table({ data }: Top20TableProps = {}) {
  const [page, setPage] = React.useState(0)
  const [rowsPerPage, setRowsPerPage] = React.useState(20)

  if (!data || !data.rows || data.rows.length === 0) {
    return <TableEmptyState />
  }

  function CreateColumns(allData: TableData): Column[] {
    const columns: Column[] = allData.columnHeaders.map((header) => ({
      id: header,
      label: header,
      minWidth: 10,
      align: 'left'
    }))
    return columns
  }

  function createRows(allData: TableData) {
    return allData.rows.map((row) => {
      const rowData: { [key: string]: string } = {}
      allData.columnHeaders.forEach((header, index) => {
        rowData[header] = row[index]
      })
      return rowData
    })
  }

  const columns = CreateColumns(data)
  const rows = createRows(data)

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value)
    setPage(0)
  }

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  sx={{
                    width: `${100 / columns.length}%`,
                    color: 'black',
                    fontWeight: 'bold',
                    whiteSpace: 'normal',
                  }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => (
                <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                  {columns.map((column) => {
                    const value = row[column.id]
                    return (
                      <TableCell key={column.id} align={column.align}>
                        {value}
                      </TableCell>
                    )
                  })}
                </TableRow>
              ))
            }
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  )
}